import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section id="garantia" className="border-b border-ink-800 bg-ink-950" data-id="element-24" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-25" data-mp="1o5zqk0x60943">
        <div className="flex flex-col items-start gap-6 rounded-xl border border-ink-700 bg-ink-900 p-7 sm:flex-row sm:p-9" data-id="element-26" data-mp="222whe2da9qkz">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-volt/40 bg-volt/10" data-id="element-27" data-mp="1x28qdgp219qr">
            <ShieldCheckIcon className="h-7 w-7 text-volt" aria-hidden="true" data-id="element-28" data-mp="14fxq675d1auh" />
          </span>
          <div data-id="element-29" data-mp="1j4ahgqti65in">
            <h2 className="font-display text-3xl font-extrabold uppercase leading-none text-white sm:text-4xl" data-id="element-30" data-mp="1j4ty847f2nv3">
              Garantía de rendimiento de 7 días
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-zinc-400" data-id="element-31" data-mp="qnzr6p5d4vc1">
              Si después de ver el plan sentís que no es para vos o que no es el sistema
              más completo que hayas visto, te devuelvo el 100% de tu dinero.
            </p>
            <p className="mt-3 font-display text-2xl font-extrabold uppercase italic text-volt" data-id="element-32" data-mp="oz02xtw5fyns">
              El riesgo de probar es mío.
            </p>
          </div>
        </div>
      </div>
    </section>;
}